import ApiService from './ApiService';
import { callAlert } from './CommonService';
import { download_pdf } from './ExportReportService';
 
class QuizService {
 
  downloadReportPdf(data=[])  { 

              
  
  
  
  let res=data;
  
  let pdfData = [];
  let rowsArr = [];
  let index=1;
  let correctAnswer=0;
  let answer=0;
  for (const [key,value] of Object.entries(res.report)) {
   
      
      rowsArr.push(
        [
          index,
          value['question'], 
          value['correctAnswer'],
          value['answer'],
          value['status']
      ]);

      if(value['status']=="CORRECT"){
        correctAnswer++
      }else{
        answer++;
      }
      index++;
  }
  
   
  pdfData.push({
    "title": `Results:- \nTotal Questions :  ${rowsArr.length}   (Correct : ${correctAnswer} & Incorrect : ${answer} Answers) `, 
    "rows": []
  });


   
      pdfData.push({
        "title": res.moduleName + "/ "+ res.videoName,
        "images": '',
        "columns": ['S. No.','Question',"Correct Answer","Selected Answer","Status"],
        "rows": rowsArr,
        "columnStyles": {}
      });
  
  
  
                   //  if (this.correlationChart.length == countLengthChart) {
      const currentDat =res.completeTime;
      var options = {
        filename: "quiz-rrogress-report ",    //Name of the downloaded files.
        heading: "Quiz  Report of " +  res.courseName  , //heading of Downloaded PDF File
        headhtml: `Quiz on completed : ${currentDat}`, //heading of Downloaded PDF File
        pagetype: 'l', // For landscape use 'l', for portrait use 'p'
        sizeunit: 'in', // in (inches),mm  8.3 x 11.7
        pdfPWidth: '8.3', // Width and height of the pdf
        pdfPHeight: '11.7', // height and height of the pdf
        headerTitleShow: true // for image only export data
      }
  
       download_pdf(options, pdfData, d => {
         
        })

  }


    downloadReports  (id)   {

    ApiService.publicGetRequest(`/quiz/quiz-report?id=${id}`,true) 
    .then((res) => { 

      if(res.data?.resultCode === 1){  
       
        this.downloadReportPdf(res?.data?.data)
        //callAlert('', res.data?.message,'success');
     
    }else{ 
      callAlert('', res.data?.message);
    }
 
    })
    .catch((error) => {
     
      callAlert('', error?.error?.message);

    });
};

    
    
}


export default new QuizService();
